export const ResetPasswordsForm = {
  flow: 'column',
  gap: 'B1',
  flex: '1',
  childExtends: 'InputField',
  childProps: {
    width: '100%',
    maxWidth: 'G+B',
    Title: { tag: 'span' },
    Input: {
      width: '100%',
      theme: 'field',
      background: 'hover',
      minHeight: 'controlH',
      round: 'radiusControl',
      fontSize: 'Z2',
      padding: '0 A'
    }
  },
  Password: {
    Title: {
      text: '{{ auth.resetPassword.newLabel | polyglot }}'
    },
    Input: {
      // One-way mirror only — see ResetEmailForm.Email.Input for why
      // `value: (el, s) => s.password` is intentionally absent.
      type: 'password',
      name: 'new-password',
      required: true,
      ariaLabel: (el) => el.call('polyglot', 'auth.resetPassword.newLabel'),
      autocomplete: 'new-password',
      placeholder: (el) => el.call('polyglot', 'auth.resetPassword.placeholder'),
      onInput: (ev, el, s) => {
        s.update({
          passwordTouched: true,
          password: el.node.value
        })
      }
    },
    Label_1: {
      show: (el, st) => st.passwordTouched === true && !st.password,
      color: 'red',
      text: '{{ auth.resetPassword.required | polyglot }}'
    }
  },
  RepeatPassword: {
    Title: {
      text: '{{ auth.resetPassword.repeatLabel | polyglot }}'
    },
    Input: {
      // One-way mirror only — see ResetEmailForm.Email.Input for why
      // `value: (el, s) => s.repeatPassword` is intentionally absent.
      type: 'password',
      name: 'repeat-password',
      required: true,
      ariaLabel: (el) => el.call('polyglot', 'auth.resetPassword.repeatLabel'),
      autocomplete: 'new-password',
      placeholder: (el) => el.call('polyglot', 'auth.resetPassword.placeholder'),
      onInput: (ev, el, s) => {
        s.update({
          repeatPasswordTouched: true,
          repeatPassword: el.node.value
        })
      }
    },
    Label_2: {
      show: (el, st) => st.repeatPasswordTouched === true && !st.repeatPassword,
      color: 'red',
      text: '{{ auth.resetPassword.repeatRequired | polyglot }}'
    },
    Label_3: {
      show: (el, st) =>
        st.passwordTouched === true &&
        st.repeatPasswordTouched === true &&
        st.password !== st.repeatPassword,
      color: 'red',
      text: '{{ auth.resetPassword.mismatch | polyglot }}'
    }
  },
  ModalFooter: {
    // White-label host: flush with the fields (the brand footer's '0 -X'
    // bleed is a modal affordance; on the branded card it set the button
    // off the field edges).
    isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
    '.isBranded': { margin: '0', padding: 'Z 0 0' },
    display: 'flex',
    flow: 'row',
    width: '100%',
    maxWidth: 'unset',
    align: 'center space-between',
    gap: 'Z',
    '@mobileL': {
      flow: 'column',
      gap: 'A2',
      childProps: {
        width: '100%'
      }
    },
    CheckButton: {
      // White-label host: the tenant accent (inert on the platform).
      extends: ['WhitelabelAccent', 'CheckButton'],
      text: (el, s) =>
        el.call(
          'polyglot',
          s.loading ? 'auth.resetPassword.updating' : 'auth.resetPassword.submit'
        ),
      disabled: (el, s) => !!s.loading,
      opacity: (el, s) => (s.loading ? '.7' : '1'),
      cursor: (el, s) => (s.loading ? 'wait' : 'pointer'),
      pointerEvents: (el, s) => (s.loading ? 'none' : 'auto'),
      type: 'submit',
      Icon: null,
      width: 'fit-content',
      minHeight: 'controlH',
      padding: '0 A',
      fontSize: 'Z2',
      fontWeight: '700',
      '@mobileL': {
        width: '100%',
        maxWidth: '100%'
      }
    },
    Title: null,
    Input: null
  }
}
